// @ts-nocheck
import {
  Box,
  Button,
  Flex,
  Title,
  Text,
  TextInput,
  SimpleGrid,
  Stepper,
  Textarea,
  Radio,
  Group,
  Checkbox,
} from '@mantine/core';
import { useLocation } from 'react-router-dom';
import { GradientButton } from 'components/GradientButton';
import evaluationImage from 'assets/evaluation/img03a.png';
import { useQuery } from '@tanstack/react-query';
import { API } from 'services';
import { useForm } from '@mantine/form';
import React, { useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import { Outlet, useNavigate } from 'react-router-dom';
import SignatureCanvas from 'react-signature-canvas';


export function AssessmentReportPage() {
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const assessmentId = queryParams.get('assessment_id');
  const apiUrl = import.meta.env.VITE_API_URL;

  const [active, setActive] = useState(0);

  const [section1, setSection1] = useState([]);

  const [activeTab, setActiveTab] = useState('');
  const handleTabChange = (tab: any) => {
    setActiveTab(tab);
  };


  const assessmentReportDetail = useQuery(['assessmentReportDetail'], () => {
    return API.getReportDetail({
      assessment_id: assessmentId,
    }).then((res) => res.data);
  });

  const report = assessmentReportDetail.data;
  const showKnowledgeRoleplayColumn = Boolean(report?.roleplay_enabled);

  const signatureRef = useRef<SignatureCanvas | null>(null);
  const formRef = useRef<HTMLFormElement | null>(null);
  const competencyBlockedMessage = "You have an entry that is marked NYC, hence, learner cannot be marked Competent, please check your entries.";

  const scrollToFirstValidationIssue = () => {
    window.requestAnimationFrame(() => {
      const formElement = formRef.current;
      if (!formElement) {
        return;
      }

      const firstErrorElement = formElement.querySelector('[data-validation-error="true"]') as HTMLElement | null;
      if (!firstErrorElement) {
        return;
      }

      const topOffset = firstErrorElement.getBoundingClientRect().top + window.scrollY - 180;
      window.scrollTo({
        top: topOffset > 0 ? topOffset : 0,
        behavior: 'smooth',
      });
    });
  };

  const scrollToFirstNYCSelection = () => {
    window.requestAnimationFrame(() => {
      const formElement = formRef.current;
      if (!formElement) {
        return;
      }

      const firstNYCInput = formElement.querySelector(
        'input[type="radio"][value="NYC"]:checked:not([name="competency"]), input[type="checkbox"][name^="outcome_cs["]:checked'
      ) as HTMLElement | null;

      if (!firstNYCInput) {
        scrollToFirstValidationIssue();
        return;
      }

      const scrollTarget = (firstNYCInput.closest('tr') as HTMLElement | null) || firstNYCInput;
      const topOffset = scrollTarget.getBoundingClientRect().top + window.scrollY - 180;

      window.scrollTo({
        top: topOffset > 0 ? topOffset : 0,
        behavior: 'smooth',
      });
    });
  };

  const hasAnyNYCSelection = (values: any) => {
    const knowledge = report?.knowledge || [];
    const outcomeSections = [...(report?.written || []), ...(report?.case || []), ...(report?.roleplay || [])];

    const knowledgeHasNYC = knowledge.some((q: any) => {
      const wa = values.outcome_wa?.[q.question_id];
      const cs = values.outcome_cs?.[q.question_id];
      const rp = values.outcome_rp?.[q.question_id];

      return (Number(q.method_wa) === 1 && wa === "NYC")
        || (Number(q.method_cs) === 1 && cs === "NYC")
        || (Number(q.method_rp) === 1 && showKnowledgeRoleplayColumn && rp === "NYC");
    });

    const outcomeSectionsHasNYC = outcomeSections.some((q: any) => values.outcome_cs?.[q.question_id] === true);

    return knowledgeHasNYC || outcomeSectionsHasNYC;
  };

  const form = useForm({
    initialValues: {
      outcome_wa: {},
      outcome_cs: {},
      outcome_rp: {},
      remarks: {},
      competency: "",
      candidate_comments: "",
      signature: "",
    },
    validate: {
      // competency: (value) => {
      //   if (!value || value.trim() === "") {
      //     return "Competency is required";
      //   }
      //   return null;
      // },
      competency: (value, allValues) => {
        if (!value || value.trim() === "") {
          return "Competency is required";
        }
      
        const knowledge = report.knowledge || [];
        const allRoleplay = report.roleplay || [];
        const writtenCase = [...(report.written || []), ...(report.case || []), ...allRoleplay];
      
        const allCInKnowledge = knowledge.every((q: any) => {
          const wa = allValues.outcome_wa?.[q.question_id];
          const cs = allValues.outcome_cs?.[q.question_id];
          const rp = allValues.outcome_rp?.[q.question_id];
          const methodWA = Number(q.method_wa) === 1;
          const methodCS = Number(q.method_cs) === 1;
          const methodRP = Number(q.method_rp) === 1;
          const rpIsCompetent = !methodRP || !showKnowledgeRoleplayColumn || rp === "C";

          return (!methodWA || wa === "C") && (!methodCS || cs === "C") && rpIsCompetent;
        });
      
        const allWrittenChecked = writtenCase.every((q: any) => {
          const wa = allValues.outcome_wa?.[q.question_id];
          return wa === true;
        });
      
        const hasNYCInKnowledge = knowledge.some((q: any) => {
          const wa = allValues.outcome_wa?.[q.question_id];
          const cs = allValues.outcome_cs?.[q.question_id];
          const rp = allValues.outcome_rp?.[q.question_id];
          let checking_nyc = false;
          if(Number(q.method_wa) === 1 && wa === "NYC"){
            checking_nyc = true;
          }
          if(Number(q.method_cs) === 1 && cs === "NYC" && !checking_nyc){
            checking_nyc = true;
          }
          if(Number(q.method_rp) === 1 && rp === "NYC" && !checking_nyc){
            checking_nyc = true;
          }

          return checking_nyc;
          

          // return wa === "NYC" || cs === "NYC";
        });
      
        const hasCheckedCSInWrittenCase = writtenCase.some((q: any) => {
          const cs = allValues.outcome_cs?.[q.question_id];
          return cs === true;
        });

        const hasCheckedCSInAnyRoleplay = allRoleplay.some((q: any) => {
          const cs = allValues.outcome_cs?.[q.question_id];
          return cs === true;
        });
      
        if (value === "C") {
          if (!allCInKnowledge || !allWrittenChecked) {
            return competencyBlockedMessage;
          }
          if (hasNYCInKnowledge || hasCheckedCSInWrittenCase || hasCheckedCSInAnyRoleplay) {
            return competencyBlockedMessage;
          }
        } else if (value === "NYC") {
          if (!hasNYCInKnowledge && !hasCheckedCSInWrittenCase) {
            return "Please ensure that at least one 'NYC' in outcome.";
          }
        }
      
        return null;
      },      
      candidate_comments: (value) => {
        if (!value || value.trim() === "") {
          return "Candidate comments are required";
        }
        return null;
      },
      signature: (value, _values) => {
        if (report?.trainer_signature) {
          return null; // skip validation if existing signature present
        }

        if (!value || value.trim() === "") {
          return "Signature is required";
        }
  
        return null;
      },
      outcome_wa: (_values, allValues) => {
        const errors: Record<string, string> = {};
    
        if (report && report.knowledge) {
          const allQuestions = [
            ...report.knowledge,
            ...report.written,
            ...report.case,
            ...(report.roleplay || []),
          ];
    
          allQuestions.forEach((q: any) => {
            const methodWA = Number(q.method_wa) === 1;
            const methodCS = Number(q.method_cs) === 1;
            const methodRP = Number(q.method_rp) === 1;
    
            const waChecked = Boolean(allValues.outcome_wa?.[q.question_id]); // checkbox = boolean
            const csChecked = !!allValues.outcome_cs?.[q.question_id]; // radio = string (e.g., "C" or "NYC")
            const rpChecked = Boolean(allValues.outcome_rp?.[q.question_id]);
    
            const isKnowledge = report.knowledge.includes(q);
            if (isKnowledge) {
              const rpRequired = methodRP && showKnowledgeRoleplayColumn;
              if ((methodWA && !waChecked) || (methodCS && !csChecked) || (rpRequired && !rpChecked)) {
                errors[q.question_id] = "Please complete all enabled assessment methods.";
              }
            }else{
              if ((methodWA || methodCS) && !(waChecked || csChecked)) {
                errors[q.question_id] = "Please select either C or NYC outcome.";
              }
            }
          }); 
        }
    
        return Object.keys(errors).length ? errors : null;
      },
      remarks: (_values, allValues) => {
        const errors: Record<string, string> = {};
      
        // === 1. Knowledge section (radio: "C" / "NYC") ===
        if (report.knowledge) {
          report.knowledge.forEach((q: any) => {
            const waValue = allValues.outcome_wa?.[q.question_id];
            const csValue = allValues.outcome_cs?.[q.question_id];
            const rpValue = allValues.outcome_rp?.[q.question_id];
            const remark = _values?.[q.question_id]; // <- direct access here
        
            const method_wa = Number(q.method_wa);
            const method_cs = Number(q.method_cs);
            const method_rp = Number(q.method_rp);
        
            let isNYC = false;
            if (method_wa === 1 && waValue === "NYC") {
              isNYC = true;
            }
            if (method_cs === 1 && csValue === "NYC") {
              isNYC = true;
            }
            if (method_rp === 1 && rpValue === "NYC") {
              isNYC = true;
            }
        
            if (isNYC && (!remark || remark.trim() === "")) {
              errors[q.question_id] = "Remarks are required for NYC outcome.";
            }
          });
        }
      
        // === 2. Written + Case section (checkbox: true/false) ===
        const checkboxSections = [
          ...(report.written || []),
          ...(report.case || []),
          ...(report.roleplay || []),
        ];
      
        checkboxSections.forEach((q: any) => {
          const csValue = allValues.outcome_cs?.[q.question_id]; // true if ticked
          const remark = _values?.[q.question_id];
      
          if (csValue === true && (!remark || remark.trim() === "")) {
            errors[q.question_id] = "Remarks are required when CS is selected.";
          }
        });
      
        return Object.keys(errors).length ? errors : null;
      }
      
    }
    
  });

  const competencyInputProps = form.getInputProps(`competency`);

  
  const handleClearSignature = () => {
    signatureRef.current?.clear();
    form.setFieldValue("signature", "");
  };

  const handleSignatureEnd = () => {
    if (!signatureRef.current || signatureRef.current.isEmpty()) {
      form.setFieldValue("signature", "");
      return;
    }

    form.setFieldValue("signature", signatureRef.current.toDataURL());
    form.clearFieldError("signature");
  };

  
  useEffect(() => {
    if (report && report.knowledge) {
      // const newOutcomeWa = {};
      // const newOutcomeCs = {};
      // const newRemarks = {}; 
      const newOutcomeWa: Record<string, boolean> = {};
      const newOutcomeCs: Record<string, boolean> = {};
      const newOutcomeRp: Record<string, string> = {};
      const newRemarks: Record<string, string> = {};
  
      Object.values(report.knowledge).forEach((q: any) => {
        // newOutcomeWa[q.question_id] = Number(q.method_wa_result) === 1;
        // newOutcomeCs[q.question_id] = Number(q.method_cs_result) === 1;
        if (q.method_wa_result == "1") {
          newOutcomeWa[q.question_id] = "C"; // Treat WA as C when used
        } else if (q.method_wa_result == "0") {
          newOutcomeWa[q.question_id] = "NYC";
        }
        if (q.method_cs_result == "1") {
          newOutcomeCs[q.question_id] = "C";
        } else if (q.method_cs_result == "0") {
          newOutcomeCs[q.question_id] = "NYC";
        }
        if (Number(q.method_rp) === 1) {
          if (q.method_rp_result == "1") {
            newOutcomeRp[q.question_id] = "C";
          } else if (q.method_rp_result == "0") {
            newOutcomeRp[q.question_id] = "NYC";
          }
        }
        
        newRemarks[q.question_id] = q.remarks || "";
      });
      Object.values(report.written).forEach((q: any) => {
        newOutcomeWa[q.question_id] = Number(q.method_wa_result) === 1;
        newOutcomeCs[q.question_id] = Number(q.method_cs_result) === 1;
        newRemarks[q.question_id] = q.remarks || "";
      });
      Object.values(report.case).forEach((q: any) => {
        newOutcomeWa[q.question_id] = Number(q.method_wa_result) === 1;
        newOutcomeCs[q.question_id] = Number(q.method_cs_result) === 1;
        newRemarks[q.question_id] = q.remarks || "";
      });
      Object.values(report.roleplay || []).forEach((q: any) => {
        newOutcomeWa[q.question_id] = Number(q.method_wa_result) === 1;
        newOutcomeCs[q.question_id] = Number(q.method_cs_result) === 1;
        newRemarks[q.question_id] = q.remarks || "";
      });
      form.setValues({
        outcome_wa: newOutcomeWa,
        outcome_cs: newOutcomeCs,
        outcome_rp: newOutcomeRp,
        remarks: newRemarks,
        competency: report.competency,
        candidate_comments: report.candidate_comments,
      });
    }
  }, [report]);
  
  const handleSubmit = async () => {
    // Capture signature before validation
    if (signatureRef.current && !signatureRef.current.isEmpty()) {
      const signatureData = signatureRef.current.toDataURL();
      form.setFieldValue("signature", signatureData);
    }
  
    // Wait for value to be set before validating
    setTimeout(() => {
      const isValid = form.validate();
      if (!isValid.hasErrors) {
        // proceed with submit
        console.log(form.values);
      } else {
        scrollToFirstValidationIssue();
      }
    }, 0);
  };

  const handleSubmitSection1 = (data: any) => {
    const validationResult = form.validate();
    if (validationResult.hasErrors) {
      scrollToFirstValidationIssue();
      return;
    }

    if (data.competency === "C" && hasAnyNYCSelection(form.values)) {
      form.setFieldError("competency", competencyBlockedMessage);
      scrollToFirstNYCSelection();
      return;
    }

    let message = ""
    if(data.competency == "C"){
      message = "You have marked the learner competent. Hence, please confirm that all outcomes have been marked Competent before submitting.";
    }

    Swal.fire({
      title: 'Are you sure?',
      text: 'Please confirm all information is correct. '+message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, submit it!',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        return API.assessmentReportSubmission({
          data: data,
          assessment_id: assessmentId,
        } as any).then((response) => {
          if (response.data.status) {
            Swal.fire({
              title: 'Thank you!',
              text: 'Your submission has been received.',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              // Optional: go to next step/page after the alert is closed
              // window.location.reload();
              navigate(`/course?course=${report.courserun_course_id}&course_run=${report.courserun_id}&first_tab=trainer&second_tab=assessment_report`);
            });
          } else {
            // Show error with SweetAlert
            Swal.fire({
              title: response.data.title || 'Error',
              text: response.data.message || 'Something went wrong.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        });
      }
    });
  };
  
  return (
    <Box bg="#f4fafe" w="100%" h="100vh" className="evalution_box">
      <SimpleGrid
        cols={2}
        bg="#e5f7f2"
        className="evalution_question_box"
        p={30}
        breakpoints={[{ maxWidth: 'md', cols: 1 }]}
      >
        <Flex className="flex_align_center">
          <Title order={2}>ASSESSMENT RECORD FORM</Title>
        </Flex>
        <Flex className="flex_justify_end">
          <img id={'welcome-image'} src={evaluationImage} alt="welcome" />
        </Flex>
      </SimpleGrid>

      <Flex
        bg="#fff"
        className="evalution_question_box"
        p={{ base: 10, sm: 20 }}
        direction="row"
        wrap="wrap"
      >
        <Flex style={{ margin: "50px 0px", flexDirection: "column", gap: "10px" }}>
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ fontWeight: "bold", width: "150px" }}>Learner Name:</div>
            <div>{report ? report.name : ''}</div>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <div style={{ fontWeight: "bold", width: "150px" }}>Learner NRIC:</div>
            <div>{report ? report.learner_nricmask : ''}</div>
          </div>
        </Flex>
        
        <form ref={formRef} onSubmit={form.onSubmit(handleSubmitSection1)} style={{ width: '100%' }}>

          <table style={{ width:"100%", border: "1px solid black", margin: "20px 0" }}>
            <thead style={{ backgroundColor: "#e5f7f2" }}>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Knowledge / Abilities</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} colSpan={showKnowledgeRoleplayColumn ? 3 : 2}><b>Assessment Method</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Overall Result<br></br>(indicate C / NYC)</b></td>
              </tr>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>WA</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>CS</b></td>
                {showKnowledgeRoleplayColumn && (
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>RP</b></td>
                )}
              </tr>
            </thead>
            {report && report.knowledge && typeof report.knowledge === 'object' ? (
              Object.values(report.knowledge).map((question: any, index: number) => (
                <tr>
                  <td style={{ width:"60%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>{`${question.question_title}`} {(Number(question.method_wa) === 1 || Number(question.method_cs) === 1 || (Number(question.method_rp) === 1 && showKnowledgeRoleplayColumn)) && <span style={{ color: 'red' }}>*</span>}
                    
                    {form.errors?.outcome_wa?.[question.question_id] && (
                      <span data-validation-error="true" style={{ color: 'red', paddingTop: '4px' }}>
                        {/* {form.errors.outcome_wa[question.question_id]} */}
                        Please mark C or NYC
                      </span>
                    )}

                  </td>
                  <td style={{ width:"100px", border: "1px solid black", textAlign: "center", padding: "40px", verticalAlign:"middle", backgroundColor: Number(question.method_wa) === 0 ? "#e9ecef" : "" }}>
                    {Number(question.method_wa) !== 0 && (
                      <Radio.Group
                        name={`method_wa[${question.question_id}]`}
                        onChange={(value) =>
                          form.setFieldValue(`outcome_wa.${question.question_id}`, value)
                        }
                        {...form.getInputProps(`outcome_wa.${question.question_id}`)}
                      >
                        <Radio value="C" label="(C)" />
                        <Radio value="NYC" label="(NYC)" />
                      </Radio.Group>
                    )}
                  </td>
                  <td style={{ width:"100px", border: "1px solid black", padding: "40px", verticalAlign:"middle", backgroundColor: Number(question.method_cs) === 0 ? "#e9ecef" : "" }}>
                    {Number(question.method_cs) !== 0 && (
                      <Radio.Group
                        name={`method_cs[${question.question_id}]`}
                        onChange={(value) =>
                          form.setFieldValue(`outcome_cs.${question.question_id}`, value)
                        }
                        {...form.getInputProps(`outcome_cs.${question.question_id}`)}
                      >
                        <Radio value="C" label="(C)" />
                        <Radio value="NYC" label="(NYC)" />
                      </Radio.Group>
                    )}
                  </td>
                  {showKnowledgeRoleplayColumn && (
                    <td style={{ width:"120px", border: "1px solid black", textAlign: "center", padding: "20px", verticalAlign:"middle", backgroundColor: Number(question.method_rp) === 0 ? "#e9ecef" : "" }}>
                      {Number(question.method_rp) !== 0 && (
                        <Radio.Group
                          name={`method_rp[${question.question_id}]`}
                          onChange={(value) =>
                            form.setFieldValue(`outcome_rp.${question.question_id}`, value)
                          }
                          {...form.getInputProps(`outcome_rp.${question.question_id}`)}
                        >
                          <Radio value="C" label="(C)" />
                          <Radio value="NYC" label="(NYC)" />
                        </Radio.Group>
                      )}
                    </td>
                  )}
                  <td style={{ width: showKnowledgeRoleplayColumn ? "calc(40% - 300px)" : "calc(40% - 200px)", border: "1px solid black", padding: "5px" }}>
                    <textarea
                      name={`remarks[${question.question_id}]`}
                      className="form-control quiz-search-input"
                      placeholder="Remarks ....."
                      rows={3}
                      {...form.getInputProps(`remarks.${question.question_id}`)}
                    />
                    {form.errors.remarks?.[question.question_id] && (
                      <div data-validation-error="true" style={{ color: "red", fontSize: "12px" }}>
                        {/* {form.errors.remarks[question.question_id]} */}
                        You have marked the learner NYC.
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <p>No questions available</p>
            )}
          </table>

          Final Assessment Outcome:
          <Radio.Group
            name={competencyInputProps.name}
            value={competencyInputProps.value}
            onChange={competencyInputProps.onChange}
            onBlur={competencyInputProps.onBlur}
          >
            <Radio value="C" label="Competent (C)" />
            <Radio value="NYC" label="Not Yet Competent (NYC)" />
          </Radio.Group>
          {form.errors.competency && (
            <div data-validation-error="true" style={{ color: "red", fontSize: "12px", marginTop: "6px" }}>
              {form.errors.competency}
            </div>
          )}

          <table style={{ width:"100%", border: "1px solid black", margin: "20px 0" }}>
            <thead style={{ backgroundColor: "#e5f7f2" }}>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Assessor’s / Candidate’s comments</b></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <textarea
                    name={`candidate_comments`}
                    className="form-control quiz-search-input"
                    placeholder="Comments ....."
                    rows={3}
                    // defaultValue={report.candidate_comments || ""}
                    {...form.getInputProps(`candidate_comments`)}
                  />
                  {form.errors.candidate_comments && (
                    <div data-validation-error="true" style={{ color: "red", fontSize: "12px" }}>
                      Please fill in comments
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{width:"100%", display:"flex", textAlign:"center"}}>

            <div style={{width:"50%"}}>
              <p style={{textAlign:"center"}}>Trainer Signature</p>
              {report && report.trainer_signature ? (
                <div>
                  <img src={apiUrl + "/" + report.trainer_signature} alt="trainer signature" />
                  <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{ report.trainer_signature_date }</p>
                </div>
              ) : (
                <div>
                  <div>
                    <SignatureCanvas
                      ref={signatureRef}
                      onEnd={handleSignatureEnd}
                      penColor="black"
                      backgroundColor="#fff"
                      canvasProps={{
                        width: 300,
                        height: 200,
                        className: 'signature-canvas',
                      }}
                    />
                    <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>

                    {form.errors?.signature && (
                      <span data-validation-error="true" style={{ color: 'red', paddingTop: '4px' }}>
                        Please sign and confirm all result is correct
                      </span>
                    )}
                  </div>
                  <div style={{ textAlign: "center", width: "300px", margin:"auto" }}>
                    <GradientButton
                      mt="sm"
                      onClick={handleClearSignature}
                      style={{
                        margin: '10px',            // Optional: Custom margin for "Clear" button
                      }}
                    >
                      Clear
                    </GradientButton>
                    {/* <GradientButton
                      mt="sm"
                      onClick={handleSaveSignature}
                      style={{
                        margin: '10px',            // Optional: Custom margin for "Save" button
                      }}
                    >
                      Submit
                    </GradientButton> */}
                  </div>
                </div>
              )}
            </div>
            
            <div style={{width:"50%"}}>
              <p style={{textAlign:"center"}}>Learner Signature</p>
              {report && report.learner_signature ? (
                <div>
                  <img src={apiUrl + "/" + report.learner_signature} alt="learner signature" />
                  <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{ report.name }</p>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{ report.learner_signature_date }</p>
                </div>
              ) : (
                <div>
                  <div style={{ height:"200px"}}>
                  </div>
                  <hr style={{width:"300px", borderTop:"1px solid #000000", textAlign:"center", margin:"auto"}} ></hr>
                  <p style={{width:"300px", textAlign:"center", margin:"auto"}}>{report ? report.name : ''}</p>

                </div>
              )}
            </div>
          </div>
          
          {report && report.section2_title && (
            <h3 style={{ margin: "50px 0" }}>{report.section2_title}</h3>
          )}

          <table style={{ width:"100%", border: "1px solid black", margin: "20px 0" }}>
            <thead style={{ backgroundColor: "#e5f7f2" }}>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Knowledge / Abilities</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Assessment Criteria</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} colSpan={2}><b>Outcome<br></br>(Tick)</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Remarks<br></br>(required if NYC indicated) </b></td>
              </tr>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>C</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>NYC</b></td>
              </tr>
            </thead>
            {report && report.written && typeof report.written === 'object' ? (
              Object.values(report.written).map((question: any, index: number) => (
                <tr key={question.question_id}>
                  <td style={{ width:"30%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>
                    {question.question_title} <span style={{ color: 'red' }}>*</span>
                    
                    {form.errors?.outcome_wa?.[question.question_id] && (
                      <span data-validation-error="true" style={{ color: 'red', paddingTop: '4px' }}>
                        {/* {form.errors.outcome_wa[question.question_id]} */}
                        Please mark C or NYC
                      </span>
                    )}
                  </td>
                  <td style={{ width:"30%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>
                    {question.question_criteria}
                  </td>
                  <td style={{ width:"100px", border: "1px solid black", textAlign: "center", padding: "40px", verticalAlign:"middle" }}>
                    <Checkbox
                      name={`outcome_wa[${question.question_id}]`}
                      disabled={Number(question.method_wa) === 0}
                      {...form.getInputProps(`outcome_wa.${question.question_id}`, { type: "checkbox" })}
                      onChange={(event) => {
                        form.setFieldValue(`outcome_wa.${question.question_id}`, event.target.checked);
                        if (event.target.checked) {
                          form.setFieldValue(`outcome_cs.${question.question_id}`, false); // Auto uncheck CS
                        }
                      }}
                    />
                  </td>
                  <td style={{ width:"100px", border: "1px solid black", padding: "40px", verticalAlign:"middle" }}>
                    <Checkbox
                      name={`outcome_cs[${question.question_id}]`}
                      disabled={Number(question.method_cs) === 0}
                      {...form.getInputProps(`outcome_cs.${question.question_id}`, { type: "checkbox" })}
                      onChange={(event) => {
                        form.setFieldValue(`outcome_cs.${question.question_id}`, event.target.checked);
                        if (event.target.checked) {
                          form.setFieldValue(`outcome_wa.${question.question_id}`, false); // Auto uncheck WA
                        }
                      }}
                    />
                  </td>
                  <td style={{ width:"calc(40% - 200px)", border: "1px solid black", padding: "5px" }}>
                    <textarea
                      name={`remarks[${question.question_id}]`}
                      className="form-control quiz-search-input"
                      placeholder="Remarks ....."
                      rows={3}
                      {...form.getInputProps(`remarks.${question.question_id}`)}
                    />
                    {form.errors.remarks?.[question.question_id] && (
                      <div data-validation-error="true" style={{ color: "red", fontSize: "12px" }}>
                        {/* {form.errors.remarks[question.question_id]} */}
                        You have marked the learner NYC.
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <p>No questions available</p>
            )}

          </table>

          {report && report.section3_title && (
            <h3 style={{ margin: "50px 0" }}>{report.section3_title}</h3>
          )}
          <table style={{ width:"100%", border: "1px solid black", margin: "20px 0" }}>
            <thead style={{ backgroundColor: "#e5f7f2" }}>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Knowledge / Abilities</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Assessment Criteria</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} colSpan={2}><b>Outcome<br></br>(Tick)</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Remarks<br></br>(required if NYC indicated) </b></td>
              </tr>
              <tr>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>C</b></td>
                <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>NYC</b></td>
              </tr>
            </thead>
            {report && report.case && typeof report.case === 'object' ? (
              Object.values(report.case).map((question: any, index: number) => (
                <tr>
                  <td style={{ width:"30%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>{`${question.question_title}`} <span style={{ color: 'red' }}>*</span>
                    
                    {form.errors?.outcome_wa?.[question.question_id] && (
                      <span data-validation-error="true" style={{ color: 'red', paddingTop: '4px' }}>
                        {/* {form.errors.outcome_wa[question.question_id]} */}
                        Please mark C or NYC
                      </span>
                    )}
                  </td>
                  <td style={{ width:"30%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>{`${question.question_criteria}`}</td>
                  <td style={{ width:"100px", border: "1px solid black", textAlign: "center", padding: "40px", verticalAlign:"middle" }}>
                    <Checkbox
                      name={`outcome_wa[${question.question_id}]`}
                      disabled={Number(question.method_wa) === 0}
                      {...form.getInputProps(`outcome_wa.${question.question_id}`, { type: "checkbox" })}
                      onChange={(event) => {
                        form.setFieldValue(`outcome_wa.${question.question_id}`, event.target.checked);
                        if (event.target.checked) {
                          form.setFieldValue(`outcome_cs.${question.question_id}`, false); // Auto uncheck CS
                        }
                      }}
                    />
                  </td>
                  <td style={{ width:"100px", border: "1px solid black", padding: "40px", verticalAlign:"middle" }}>
                    <Checkbox
                      name={`outcome_cs[${question.question_id}]`}
                      disabled={Number(question.method_cs) === 0}
                      {...form.getInputProps(`outcome_cs.${question.question_id}`, { type: "checkbox" })}
                      onChange={(event) => {
                        form.setFieldValue(`outcome_cs.${question.question_id}`, event.target.checked);
                        if (event.target.checked) {
                          form.setFieldValue(`outcome_wa.${question.question_id}`, false); // Auto uncheck WA
                        }
                      }}
                    />
                  </td>
                  <td style={{ width:"calc(40% - 200px)", border: "1px solid black", padding: "5px" }}>
                    <textarea
                      name={`remarks[${question.question_id}]`}
                      className="form-control quiz-search-input"
                      placeholder="Remarks ....."
                      rows={3}
                      {...form.getInputProps(`remarks.${question.question_id}`)}
                    />
                    {form.errors.remarks?.[question.question_id] && (
                      <div data-validation-error="true" style={{ color: "red", fontSize: "12px" }}>
                        {/* {form.errors.remarks[question.question_id]} */}
                        You have marked the learner NYC.
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <p>No questions available</p>
            )}
          </table>

          {report && report.roleplay_enabled && report.section4_title && (
            <h3 style={{ margin: "50px 0" }}>{report.section4_title}</h3>
          )}
          {report && report.roleplay_enabled && (
            <table style={{ width:"100%", border: "1px solid black", margin: "20px 0" }}>
              <thead style={{ backgroundColor: "#e5f7f2" }}>
                <tr>
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Knowledge / Abilities</b></td>
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Assessment Criteria</b></td>
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} colSpan={2}><b>Outcome<br></br>(Tick)</b></td>
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }} rowSpan={2}><b>Remarks<br></br>(required if NYC indicated) </b></td>
                </tr>
                <tr>
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>C</b></td>
                  <td style={{ textAlign:"center", verticalAlign:"middle",border: "1px solid black" }}><b>NYC</b></td>
                </tr>
              </thead>
              {report && report.roleplay && typeof report.roleplay === 'object' ? (
                Object.values(report.roleplay).map((question: any) => (
                  <tr key={question.question_id}>
                    <td style={{ width:"30%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>
                      {`${question.question_title}`} <span style={{ color: 'red' }}>*</span>
                      {form.errors?.outcome_wa?.[question.question_id] && (
                        <span data-validation-error="true" style={{ color: 'red', paddingTop: '4px' }}>
                          Please mark C or NYC
                        </span>
                      )}
                    </td>
                    <td style={{ width:"30%", border: "1px solid black", padding: "5px", verticalAlign:"middle" }}>{`${question.question_criteria}`}</td>
                    <td style={{ width:"100px", border: "1px solid black", textAlign: "center", padding: "40px", verticalAlign:"middle" }}>
                      <Checkbox
                        name={`outcome_wa[${question.question_id}]`}
                        disabled={Number(question.method_wa) === 0}
                        {...form.getInputProps(`outcome_wa.${question.question_id}`, { type: "checkbox" })}
                        onChange={(event) => {
                          form.setFieldValue(`outcome_wa.${question.question_id}`, event.target.checked);
                          if (event.target.checked) {
                            form.setFieldValue(`outcome_cs.${question.question_id}`, false);
                          }
                        }}
                      />
                    </td>
                    <td style={{ width:"100px", border: "1px solid black", padding: "40px", verticalAlign:"middle" }}>
                      <Checkbox
                        name={`outcome_cs[${question.question_id}]`}
                        disabled={Number(question.method_cs) === 0}
                        {...form.getInputProps(`outcome_cs.${question.question_id}`, { type: "checkbox" })}
                        onChange={(event) => {
                          form.setFieldValue(`outcome_cs.${question.question_id}`, event.target.checked);
                          if (event.target.checked) {
                            form.setFieldValue(`outcome_wa.${question.question_id}`, false);
                          }
                        }}
                      />
                    </td>
                    <td style={{ width:"calc(40% - 200px)", border: "1px solid black", padding: "5px" }}>
                      <textarea
                        name={`remarks[${question.question_id}]`}
                        className="form-control quiz-search-input"
                        placeholder="Remarks ....."
                        rows={3}
                        {...form.getInputProps(`remarks.${question.question_id}`)}
                      />
                      {form.errors.remarks?.[question.question_id] && (
                        <div data-validation-error="true" style={{ color: "red", fontSize: "12px" }}>
                          You have marked the learner NYC.
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <p>No questions available</p>
              )}
            </table>
          )}
          
          {/* {report && report.report_id == "0" && ( */}
            <Flex className="flex_justify_end" w="100%">
              <GradientButton type="submit" mt="sm" onClick={handleSubmit}>
                Submit
              </GradientButton>
            </Flex>
          {/* )} */}
        </form>


      </Flex>
    </Box>
  );
}
